export default "__VITE_ASSET__Pt3zWW5o__"